import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@material-ui/core';
import closeButtonStyles from './CloseButtonStyle';

export interface ICloseButtonProps {
  /**
   * Data test used on integration testing
   */
  dataTest: string;
}

export const CloseButton: FunctionComponent<ICloseButtonProps> = ({ dataTest }: ICloseButtonProps) => {
  const styles = closeButtonStyles();

  return (
    <SvgIcon data-test={dataTest} viewBox="0 0 25 25" className={styles.icon}>
      <path
        d="M25,37.5a13.21,13.21,0,0,1-2.52-.25,13,13,0,0,1-2.35-.73A12.47,12.47,0,0,1,18,35.36,12.28,12.28,0,0,1,14.64,
            32a12.47,12.47,0,0,1-1.16-2.12,13,13,0,0,1-.73-2.35,12.83,12.83,0,0,1,0-5,13,13,0,0,1,.73-2.35A12.47,12.47,0,0,1,
            14.64,18,12.28,12.28,0,0,1,18,14.64a12.47,12.47,0,0,1,2.12-1.16,13,13,0,0,1,2.35-.73,12.83,12.83,0,0,1,5,0,13,
            13,0,0,1,2.35.73A12.47,12.47,0,0,1,32,14.64,12.28,12.28,0,0,1,35.36,18a12.47,12.47,0,0,1,1.16,2.12,13,13,0,0,
            1,.73,2.35,12.83,12.83,0,0,1,0,5,13,13,0,0,1-.73,2.35A12.47,12.47,0,0,1,35.36,32,12.28,12.28,0,0,1,32,35.36a12.47,
            12.47,0,0,1-2.12,1.16,13,13,0,0,1-2.35.73A13.21,13.21,0,0,1,25,37.5Z"
        transform="translate(-12.5 -12.5)"
      />
      <g id="OW9wL5">
        <path
          className={styles.closeIcon}
          d="M25,27.07l-4,3.95a7,7,0,0,1-.69.64,1.33,1.33,0,0,1-1.95-.19,1.28,1.28,0,0,1,.08-1.95c1.19-1.21,2.41-2.41,
            3.61-3.62.26-.27.53-.53.87-.87l-3.6-3.6c-.25-.25-.5-.49-.74-.75a1.45,1.45,0,0,1-.08-2.13,1.42,1.42,0,0,1,
            2.13.06c1.18,1.14,2.32,2.31,3.48,3.47L25,23c1.49-1.49,2.92-2.91,4.33-4.34a1.44,1.44,0,1,1,2.1,1.95c-1.14,1.22-2.35,
            2.38-3.53,3.56l-.86.87,3.6,3.6c.25.25.51.48.74.75a1.42,1.42,0,0,1,0,2.13,1.36,1.36,0,0,
            1-2.05-.07c-1.18-1.12-2.32-2.3-3.48-3.46Z"
          transform="translate(-12.5 -12.5)"
        />
      </g>
    </SvgIcon>
  );
};

export default CloseButton;
